module.exports = __webpack_public_path__ + "img/unit-gray.svg";